<!-- FORM TITLE HEADER -->
@if (msfps.isBuyerManagementPreview || msfps.mode === 'supplierEdit' || msfps.mode === 'previewDisabled') {
  <div class="row mb-3">
    <div class="col-12">
      <span class="fs-5 fw-bold">Form Preview - {{ formTitle }}</span>
      <hr class="mt-2 mb-0" />
    </div>
  </div>
}

<!-- No logic Alert -->
<app-alert-no-logic />

<div class="container-fluid position-relative">
  <!-- SM-3009: Close ("X") button - navigates back to the Angular app -->
  @if (msfps.isBuyerManagementPreview || msfps.mode === "supplierEdit" || msfps.mode === "previewDisabled") {
    <button
      type="button"
      class="preview-close-btn"
      title="Close"
      aria-label="Close"
      (click)="msfps.closePreview()"
    >
      <i class="fa fa-times"></i>
    </button>
  }
  <div class="row">
    <div class="col-3">
      <button
        type="button"
        class="d-none btn btn-danger mb-2"
        (click)="msfps.toggleJsonStructure = !msfps.toggleJsonStructure"
      >
        Toggle JSON
      </button>

      <div
        class="row"
        [ngClass]="
          msfps.isBuyerManagementPreview || msfps.mode === 'supplierEdit'
            ? 'management-li-preview'
            : 'editor-li-preview'
        "
      >
        @if (
          msfps.allFields?.length &&
          msfps.fieldsSegregatedIntoSections &&
          msfps.activeSecInfo
        ) {
          <app-list-sections-and-fields />
        }
      </div>
      <div class="row">
        <app-legend-information />
      </div>
    </div>
    <div class="col-9">
      <div class="row">
        <app-preview-breadcrumbs />
      </div>
      <hr class="my-2" />
      <div
        class="row"
        [ngClass]="
          msfps.isBuyerManagementPreview || msfps.mode === 'supplierEdit'
            ? 'management-sn-preview'
            : 'editor-sn-preview'
        "
      >
        @if (
          msfps.allFields?.length &&
          msfps.fieldsSegregatedIntoSections &&
          msfps.activeSecInfo
        ) {
          <app-current-section-all-fields-preview />
        }
      </div>
      <div class="row text-right">
        <app-footer-buttons (modalClose)="close($event)" />
      </div>
    </div>
  </div>
</div>

<app-scores-analysis></app-scores-analysis>
<app-submit-survey-confirmation></app-submit-survey-confirmation>
